<template>
  <div style="width: 1517px; height: 1080px" class="map-box">
    <el-amap
      v-if="showMap"
      class="amap-box"
      ref="amap"
      vid="amap-vue"
      :center="center"
      :plugin="plugin"
      :zoom="zoom"
      :mapStyle="mapStyle"
    >
      <div :key="idx" v-for="(item, idx) in polygonlist">
        <el-amap-polygon v-bind="polygonConfig" :path="item.path"></el-amap-polygon>
        <el-amap-marker
          v-if="mapType == 1"
          :key="idx"
          :offset="[0, 0]"
          :position="item.center"
        >
          <div style="display: flex; position: relative">
            <el-tooltip
              effect="dark"
              :content="item.name"
              placement="top-start"
              style="color: #fff; font-size: 16px;"
            >
              <div class="amap-overlay-text"></div>
            </el-tooltip>
          </div>
        </el-amap-marker>
        <el-amap-marker
          v-if="mapType == 2"
          :key="idx"
          :offset="[-60, -60]"
          :position="item.center"
        >
          <div style="display: flex; position: relative" @click="setMap(item)">
            <el-popover
              placement="right"
              trigger="hover"
              width="325"
              style="height: 230px"
            >
              <!-- <img
                style="width: 99px; height: 78px"
                :src="require('@/assets/daping/jiantou.png')"
                alt=""
                slot="reference"
              /> -->
              <div slot="reference" class="amap-overlay-text">
                <!-- {{ item.name }} -->
              </div>
              <div class="mapfc">
                <div class="point-name">{{ item.name }}</div>
                <div class="point-list">
                  <div
                    v-for="(itemList, index) in listData"
                    :key="index"
                    :class="['list', `list${index}`]"
                  >
                    <div>
                      <div class="name">{{ itemList.name }}</div>
                      <div :class="['name', 'num', `num${index}`]">
                        <span v-if="index != 4">
                          {{ item[itemList.valueLi] }}
                        </span>
                        <span v-if="index == 4">
                          {{ item[itemList.valueLi] ? item[itemList.valueLi] : 0 }}%
                        </span>
                      </div>
                    </div>
                    <div
                      v-if="index != 2 && index != 4"
                      style="
                        height: 20px;
                        width: 1px;
                        background: rgba(0, 163, 255, 0.31);
                      "
                    ></div>
                  </div>
                </div>
              </div>
            </el-popover>
            <!-- <el-tooltip
              class="item"
              effect="dark"
              :content="item.name"
              placement="top-start"
            >
              <img
                style="width: 99px; height: 78px"
                :src="require('@/assets/daping/jiantou.png')"
                alt=""
              />
            </el-tooltip> -->
            <!--            <div class="map_text">{{item.userCount}}人</div>-->
          </div>
        </el-amap-marker>
        <el-amap-marker
          v-for="(itea, indea) in pointList1"
          :key="indea + pointList1.length"
          v-if="mapType == 3"
          :offset="[-30, -48]"
          :position="[itea.pointLongitude, itea.pointLatitude]"
        >
          <div style="display: flex; position: relative" @click="setMapReport(itea)">
            <el-tooltip
              class="item"
              effect="dark"
              :content="itea.pointName"
              placement="top-start"
            >
              <img
                style="width: 60px; height: 48px"
                :src="require('@/assets/image/quanbu_dian.svg')"
                alt=""
              />
            </el-tooltip>
          </div>
        </el-amap-marker>
      </div>
    </el-amap>
    <div class="total-num">
      <div class="list">
        <img src="@/assets/daping/dianwei.png" />
        <div class="num">
          <div>区域点位/个</div>
          <div class="number">{{ mapListData.pointCount }}</div>
        </div>
      </div>
      <div class="list">
        <img src="@/assets/daping/zxr.png" />
        <div class="num">
          <div>区域网格员/人</div>
          <div class="number">{{ mapListData.personCount }}</div>
        </div>
      </div>
    </div>
    <div class="option_box">
      <div class="title">图层切换</div>
      <div
        class="option_box_item"
        v-for="(item, index) in matList"
        :key="index"
        @click="setMapTop(item)"
      >
        <div class="item_left">
          <img style="width: 24px" :src="item.icon" />
          <div class="item_name">{{ item.title }}</div>
        </div>
        <img src="@/assets/image/xuanzhong.svg" v-if="item.title == mapTitle" />
        <img v-else src="@/assets/image/weixuanzhong.svg" />
      </div>
    </div>

    <pointReportDetail
      v-if="pointInfoDialogVisible"
      :formList="pointListData"
      :dialogVisible.sync="pointInfoDialogVisible"
    ></pointReportDetail>
  </div>
</template>

<script>
import Vue from "vue";
import VueAMap from "vue-amap";
import geoJsonOne from "./mapsOne.json";
import geoJson from "./maps.json";
Vue.use(VueAMap);
import { pastTenMinReportDistribution } from "@/api/task.js";
import pointReportDetail from "./pointReportDetail.vue";
import { getPointGeoJson } from "@/api/point.js";
export default {
  name: "AMap",
  props: {
    mapListData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    pointReportDetail,
  },

  data() {
    return {
      listData: [
        {
          name: "网格数",
          valueLi: "wgCount",
        },
        {
          name: "网格员",
          valueLi: "wgPersonCount",
        },
        {
          name: "上报问题数",
          valueLi: "reportCount",
        },
        {
          name: "处置问题数",
          valueLi: "handleCount",
        },
        {
          name: "处置率",
          valueLi: "handleRate",
        },
      ],
      showMap: false,
      amap: null,
      map: null,
      mapApiKey: "f6a6784aeb8609f7920f60ba3161ae54", //您申请的key值
      markersArray: [114.039587, 22.699961],
      zoom: 15,
      lnglatInfo: {
        lng: "",
        lat: "",
        addr: "",
      },
      searchOption: {
        city: "全国",
        citylimit: true,
      },
      // center: [114.039587, 22.699961],
      center: [116.334529, 39.977991],
      defaultIcon: require("@/assets/image/add.png"),
      plugin: [
        // {
        //   pName: "Scale",
        //   events: {
        //     init(instance) {
        //       // console.log(instance)
        //     }
        //   }
        // },
        // {
        //   pName: "ToolBar",
        //   position: "RT",
        //   events: {
        //     init(instance) {
        //       // console.log(instance)
        //     }
        //   }
        // }
      ],
      events: {},
      // 绘制边界
      polygonConfig: {
        // 城市边界 配置
        strokeColor: "rgba(0, 163, 255, 1)", // 城市边界颜色
        strokeWeight: 2,
        strokeStyle: "dashed", // 线样式
        fillColor: "rgba(0, 163, 255, 1)", // 遮罩背景色
        fillOpacity: 0.1,
      },
      polygonConfig2: {
        // 城市边界 配置
        strokeColor: "#47536e", // 城市边界颜色
        strokeWeight: 2,
        strokeStyle: "dashed", // 线样式
        fillColor: "#47536e", // 遮罩背景色
        fillOpacity: 0.1,
      },
      polygons: {
        // 城市边界数据
        De: {},
      },
      district: null,
      polygonlist: [],
      polygonlistOne: [],
      mapStyle: "amap://styles/darkblue",
      heatmap: null,
      // mapStyle:'',
      // sqList: ["希格玛社区"]
      isType: true,
      mapTitle: "问题热力图",
      matList: [
        { title: "基础图层", id: 1, icon: require("@/assets/daping/jctc.svg") },
        { title: "问题热力图", id: 2, icon: require("@/assets/daping/rlt.svg") },
        { title: "近十分钟巡查图", id: 3, icon: require("@/assets/daping/jsfzxct.svg") },
      ],
      pointList1: [],
      mapType: 2,
      pointListData: {},
      pointInfoDialogVisible: false,
    };
  },
  created() {
    this.showMap = false;
  },
  mounted() {
    this.$nextTick(() => {
      this.showMap = true;
      this.init();
    });
  },
  beforeDestroy() {
    this.showMap = false;
    this.amap = null;
  },
  methods: {
    // 初始化地图
    init() {
      let _self = this;
      VueAMap.initAMapApiLoader({
        key: _self.mapApiKey,
        plugin: [
          "AMap.AutoComplete",
          "AMap.PlaceSearch",
          "AMap.Scale",
          "AMap.OverView",
          "AMap.ToolBar",
          "AMap.MapType",
          "AMap.PolyEditor",
          "AMap.CircleEditor",
          "AMap.Geocoder",
          "AMap.Boundary",
          "AMap.DistrictSearch",
          "AMap.Geolocation",
          "AMap.GeoJSON",
          "AMap.Heatmap",
        ],
        // 高德 sdk 版本
        v: "1.4.15",
      });
      setTimeout(async () => {
        _self.amap = _self.$refs.amap.$$getInstance();
        _self.addHeadMap();
        _self.addGeo(_self.mapListData.pointInfoList);
        let pointList = _self.mapListData.pointInfoList.filter(
          (item) => item.pointLongitude
        );
        let points = pointList.map((item) => {
          if (item.pointLongitude) {
            return {
              lng: item.pointLongitude,
              lat: item.pointLatitude,
              count: item.reportCount,
            };
          }
        });
        _self.heatmap.setDataSet({ data: points, max: 10 });
      }, 1000);
    },
    async addGeo(pointInfoList) {
      // 社区边界示例
      const that = this;
      that.polygonlist = [];
      that.polygonlistOne = [];

      let params = {
        needGeoJson: true,
        levelCode: 3,
        pointName: ""
      };
      const res = await getPointGeoJson(params);
      let pointGeoJsonList = res.data.data.pointGeoJsonList || [];
      let features = [];
      pointGeoJsonList.forEach(item => {
        let geoJson = JSON.parse(item.geoJson);
        if (item.geoJson && geoJson.features && geoJson.features.length) {
          features.push({
            geometry: geoJson.features[0].geometry,
            type: geoJson.features[0].type,
            properties: {
              parentName: item.pointName ? item.pointName.split('-')[0] : '',
              name: item.pointName || ''
            }
          })
        }
      })
      features.forEach((item) => {
        if (
          item.geometry.coordinates &&
          item.geometry.coordinates.length &&
          item.properties &&
          item.properties.name &&
          item.properties.name.indexOf("网格") > -1
        ) {
          that.polygonlist.push({
            path: item.geometry.coordinates,
            ...item.properties,
            name: item.properties.name,
          });
        }
      });
      that.polygonlist.forEach((item) => {
        pointInfoList.forEach((pointItem) => {
          if (item.name == pointItem.pointName) {
            if (pointItem.pointLongitude) {
              item.center = [pointItem.pointLongitude, pointItem.pointLatitude];
            } else {
              item.center = item.geometry.coordinates[0][0];
            }
            item.wgCount = pointItem.wgCount;
            item.wgPersonCount = pointItem.wgPersonCount;
            item.reportCount = pointItem.reportCount;
            item.handleCount = pointItem.handleCount;
            item.handleRate = pointItem.handleRate;
          }
        });
      });
    },

    // 添加热力图
    addHeadMap() {
      const that = this;
      that.amap.plugin(["AMap.Heatmap"], function () {
        //加载热力图插件
        that.heatmap = new AMap.Heatmap(that.amap, {
          radius: 25, //给定半径
          opacity: [0, 0.8],
        });
      });
    },
    setMapTop(item) {
      this.mapTitle = item.title;
      this.mapType = item.id;
      if (item.title == "基础图层") {
        this.heatmap.setDataSet({ data: [] });
      } else if (item.title == "问题热力图") {
        this.addHeadMap();
        let pointList = this.mapListData.pointInfoList.filter(
          (item) => item.pointLongitude
        );
        let points = pointList.map((item) => {
          if (item.pointLongitude) {
            return {
              lng: item.pointLongitude,
              lat: item.pointLatitude,
              count: item.reportCount,
            };
          }
        });
        this.heatmap.setDataSet({ data: points, max: 10 });
      } else {
        this.heatmap.setDataSet({ data: [] });
        this.pastTenMinReportDistribution();
      }
    },
    pastTenMinReportDistribution() {
      pastTenMinReportDistribution({
        min: 10,
      }).then((res) => {
        this.pointList1 = res.data.data;
        console.log(res.data.code);
      });
    },
    setMapReport(item) {
      this.pointListData = item;
      this.pointInfoDialogVisible = true;
    },
  },
  watch: {
    mapListData: {
      deep: true,
      handler(val) {
        this.addHeadMap();
        this.addGeo(val.pointInfoList);
        let pointList = val.pointInfoList.filter((item) => item.pointLongitude);
        let points = pointList.map((item) => {
          if (item.pointLongitude) {
            return {
              lng: item.pointLongitude,
              lat: item.pointLatitude,
              count: item.reportCount,
            };
          }
        });

        this.heatmap.setDataSet({ data: points, max: 10 });
      },
    },
  },
};
</script>

<style lang="less" scoped>
.el-popover {
  border: 0px solid #ebeef5;
  padding: 0px;
  background: transparent;
}
</style>
<style lang="less" scoped>
.map-box {
  position: relative;
  margin-top: -40px;
  background: url("~@/assets/daping/bg-map.png") center center no-repeat;
  .total-num {
    position: absolute;
    top: 50px;
    left: 50px;
    color: #fff;
    .list {
      margin-bottom: 25px;
      display: flex;
      align-items: center;
      .num {
        font-size: 16px;
        color: #adc2d3;
        margin-left: 12px;
        .number {
          font-size: 22px;
          color: #e4f2ff;
        }
      }
    }
    img {
      width: 59px;
      height: 60px;
    }
  }
}
.amap-box {
  width: 100%;
  min-height: 505px;
}
/deep/.amap-logo {
  right: 0 !important;
  left: auto !important;
  display: none !important;
}

/deep/.amap-copyright {
  right: 70px !important;
  left: auto !important;
  opacity: 0 !important;
}

/deep/ .el-dialog__header {
  border-bottom: 0 !important;
}
.point {
  width: 300px;
  padding: 10px 24px;
  background: #fff;
  font-weight: 700;
  text-align: center;
  font-size: 14px;
  color: #494c4f;
  box-shadow: 0px 2px 4px 0px rgba(22, 54, 79, 0.08);
  border-radius: 33px;
}

.amap-overlay-text {
  width: 120px;
  height: 120px;
  // background-color: #00a3ff;
  // font-size: 20px;
  // color: #e4f2ff;
  // display: block;
  // width: auto;
  // word-break: keep-all;
  // white-space: nowrap;
  // overflow: hidden;
  // text-overflow: ellipsis;
  // padding: 2px 3px;
  // background: rgba(4, 20, 50, 0.4);
  // border-radius: 4px;
  // border: 1px solid;
  // border-image: linear-gradient(180deg, rgba(0, 208, 255, 0), rgba(0, 163, 255, 1)) 1 1;
  // backdrop-filter: blur(4px);
}

.mapfc {
  // position: absolute;
  // top: 50px;
  // right: 50px;
  background: url("~@/assets/daping/mapfc.png") center center no-repeat;
  background-size: 100% 100%;
  width: 325px;
  height: 230px;
  .point-name {
    font-family: MiSans, MiSans;
    font-weight: 600;
    font-size: 24px;
    color: #f3f8ff;
    line-height: 48px;
    text-align: left;
    font-style: normal;
    background: linear-gradient(90deg, #ddefff 0%, #5bacef 100%);
    color: transparent;
    -webkit-background-clip: text;
    background-clip: text;
    text-shadow: 0px 5px 10px rgba(3, 9, 24, 0.2);
    margin: 10px;
    padding-top: 10px;
  }
  .point-list {
    display: flex;
    flex-wrap: wrap;
    padding: 0 24px 24px 24px;
    .list {
      margin-top: 20px;
      width: 32%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .list0 {
      width: 26%;
      margin-right: 20px;
    }
    .list1 {
      width: 26%;
      margin-right: 20px;
    }
    .list2 {
      width: 33%;
    }
    .list3 {
      width: 42%;
      margin-right: 20px;
    }
    .name {
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 16px;
      color: #adc2d3;
      line-height: 22px;
      text-align: left;
      font-style: normal;
    }
    .num {
      color: #e4f2ff;
      margin-top: 4px;
    }
    .num2 {
      color: #00a3ff;
    }
  }
}

.option_box {
  width: 264px;
  height: 250px;
  background: rgba(10, 19, 35, 0.7);
  border-radius: 8px;
  backdrop-filter: blur(1px);
  padding: 15px;
  position: absolute;
  bottom: 40px;
  left: 40px;
  z-index: 1999;
  .title {
    font-weight: 400;
    font-size: 20px;
    color: #cde8fa;
  }
  .title1 {
    color: #494c4f;
  }
  .option_box_item {
    width: 224px;
    height: 48px;
    background: linear-gradient(rgba(0, 163, 255, 0.2) 1%, rgba(0, 155, 255, 0) 100%),
      radial-gradient(
        185% 50% at 51% 100%,
        rgba(0, 188, 255, 0.25) 0%,
        rgba(0, 155, 255, 0) 100%
      );
    box-shadow: inset 0px 0px 8px 0px rgba(0, 163, 255, 0.71);
    border-radius: 4px;
    border: 1px solid rgba(0, 163, 255, 0.4);
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 15px;
    padding: 0px 10px;
    .item_left {
      display: flex;
      align-items: center;
      .item_name {
        font-weight: 400;
        font-size: 18px;
        color: #cde8fa;
        margin-left: 10px;
      }
      .item_name1 {
        color: #494c4f;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/patrolScreen/components/centerItem/components/mapTop.vue